var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgItem"},[_c('img',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"src":_vm.img,"alt":""}}),_c('span',{staticClass:"imgName"},[_vm._v("《"+_vm._s(_vm.imgName)+"》")])])
}
var staticRenderFns = []

export { render, staticRenderFns }